import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import logo1 from "../../images/logo1.png";
import investmentCart from "../../images/investment-cart.svg";
import search from "../../images/search.svg";
import callBtn from "../../images/call-expert.svg";
import emailBtn from "../../images/Email-Us.svg";
import styled from 'styled-components';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import CartSelector from 'views/cart/cart.selector';
import { redirectToMintPro, redirectToHome, isProUser, redirectToOld, logOutUser, addAgentCode, isBtoCFlow, getName, isAgentEuin } from '__utils/common-utils';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import { COLOR } from 'constants/colors';
import { MintHeadingH3 } from 'views/common-styled-components';
import elementVisibilty from '__utils/toggleVisibilty-util';
import LoginSelector from 'views/login/login.selector';
import profile from 'images/profile.svg';
import { investmentFrequencyFilter } from '__utils/common-utils';
import { SuccessButton } from 'components/button';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { ENDPOINTS } from 'constants/endpoints';
import { useDeepCompare } from 'hooks/use-deep-memo';
import ProfileViewSelector from 'views/investor-profile/profile-view.selector';
import RiskProfileViewSelector from 'views/investor-profile/risk-profile/risk-profile.selector';
import { getheaderIconSetForRoute } from 'routes';
import CustomerLoader from 'images/landing-page-loader.gif';
import myCustomerSvg from 'images/my-customer.svg';
import backToMintPro from 'images/back-to-mintpro.svg';
import { CalculatorAdvisor } from 'components/common-components';
import UserSelector from 'views/user/user.selector';
import BrowseFunds from 'views/home/funds-by-category';

const HeaderContainer = styled.header<CommonStyledComponentProps>`
    left: 0;
    width: 100%;
    z-index: 1050;
    top: 0;
    &.stickyHeader{
        position: ${props => props.isMobile ? 'fixed' : 'relative'};
        height: ${props => props.isMobile ? '48px' : ''};
    }
`;

const HeaderInnerContainer = styled.div<CommonStyledComponentProps>`
    position: relative;
    background-color: ${COLOR.WHITE};
    border-bottom: 1px solid lightgrey;
    padding: ${props => props.isMobile ? '12px 16px' : '4px 30px 0px 30px'};
    box-shadow: 0 2px 4px 0 ${COLOR.LIGHTGREY};
`;

const HeaderLeft = styled.div`
    margin-right: 0 !important;
    float: left; 
    
    .headerIconSet {
        font-size: 22px;
        line-height: 1.5;  
        color: ${COLOR.GREY};
        position: absolute;
    }
`;

const HeaderCenter = styled.div<CommonStyledComponentProps>`
    position: ${props => props?.isMobile ? 'absolute' : ''};
    text-align: center;
    left: 190px;
    top: 0;
    z-index: 5;
    // padding-top: 25px;
    padding-left: 0;
    color: ${COLOR.BLACK};
`;

const HeaderNoOfItemsContainer = styled.p`
    background-color: ${COLOR.GREEN};
    width: 14px;
    font-style: normal;
    height: 14px;
    position: absolute;
    top: -5px;
    right: 10px;
    text-align: center;
    line-height: 15px;
    display: inline-block;
    color: #fff;
    text-decoration: none;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    background-color: #00a465;
    border-radius: 100%;
    -moz-border-radius: 100%;
    -webkit-border-radius: 100%;
`;

interface LogoProps {
    isMobile: boolean
}
const Logo = styled.img<LogoProps>`
    height: ${props => props.isMobile ? '39px' : '55px'};
    // width: ${props => props.isMobile ? '130px' : ''};
    margin-top: ${props => props.isMobile ? '0' : '-7px'};
`;

const HeaderTitle = styled(MintHeadingH3)`
    font-weight: 400;
    font-size: 16px;
    text-transform: capitalize;
    display: inline-block;
    margin: 4px 0 0 50px;
    white-space: nowrap;
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    left: 0;
`;

const HeaderBackCTACont = styled.div`
    padding-left: 10px;
    color: ${COLOR.DARKGREEN};
    height: 35px;
    font-size: 14px;
    box-shadow: 0 1px 4px 0 ${COLOR.LIGHTGREY};
    background-color: ${COLOR.GREY_BG};
    line-height: 30px;
    vertical-align: middle;
    i {
        font-size: 20px;
        vertical-align: middle;
    }
`;
const ViewCartButton = styled(SuccessButton)`
        width: auto;
        margin: 10px auto;
        display: block;
        border-radius: 4px;
        color: white;
        line-height: 20px !important;
        margin-left: 10px !important;
        height: unset;
        font-size:12px;
        font-weight:400;
`;

const HeaderSearch = styled.div<CommonStyledComponentProps>`
    float: none;
    height: auto;
    position: relative;
    width: 100%;
    display: inline-block;
    text-decoration: none;
    background-color: #fff;
    border-radius: 4px;
    border: solid 1px ${COLOR.LIGHTGREY};
    font-size: 12px;
    line-height: normal;
    color: #9e9e9e;
    padding: 10px;
    img {
        opacity: .5;
        height: 22px;
        position: absolute;
        top: 6px;
    }
    input {
        height: 12px;
        width: ${props => props.isMobile ? '100%' : '484px'};
        padding: 0;
        border: 0;
        color: #9e9e9e;
        font-size: 12px;
        padding-left: 27px;
        background-color: #fff;
    }
    input::placeholder {
        color: ${props => props.isMobile ? 'black' : '#9e9e9e6e'};
        font-weight: 400 !important;
    }
    .srch-btn {
        right: -1px;
        position: absolute;
        top: -1px;
        bottom: -1px;
        width: 75px;
        height: 30px;
        border-radius: 2px;
        border: solid 1px ${COLOR.GREEN};
        color: ${COLOR.GREEN};
        padding: 0;
    }
`;

const LoginSignUpButton = styled.span`
    display: inline-block;
    padding: 5px 15px;
    width: 120px;
    font-size: 12px;
    color: #001837;
    letter-spacing: .3px;
    align-items: center;
    border: 1px solid ${COLOR.GREEN};
    color: ${COLOR.GREEN};
    border-radius: 2px;
    margin-left: 7px;
    cursor: pointer;
`;
const HeaderRight = styled.div<CommonStyledComponentProps>`
  float: right;
  position: relative;
  z-index: 15;
  .anchorBlack {
    color: ${COLOR.GREY};
    position: relative;
  }
  .expert-call-header {
    justify-content: center;
    align-items: center;
    display: grid;
    grid-template-columns: repeat(1, 0.4fr 2fr);
    margin: 0 15px;
    grid-gap: 8px;
  }
  .expert-call-header-mobile {
    justify-content: center;
    align-items: center;
    display: grid;
    margin: 0 15px 0 0;
    grid-gap: 8px;
  }
  .expert-call-header p {
    font-size: 12px;
    line-height: normal;
    padding-left: -20px;
  }
  .expert-call-header span.green {
    color: ${COLOR.GREEN};
    font-weight: bold;
  }

  .email-support-header {
    justify-content: center;
    align-items: center;
    display: grid;
    grid-template-columns: repeat(1, 0.4fr 2fr);
    margin: 0 15px;
    grid-gap: 8px;
  }

  .email-support-header p {
    font-size: 12px;
    line-height: normal;
    padding-left: -20px;
  }

  .email-support-header span.green {
    color: ${COLOR.GREEN};
    font-weight: bold;
  }

  .email-support-header img {
    vertical-align: middle;
  }

  .email-support-header-mobile {
    justify-content: center;
    align-items: center;
    display: grid;
    margin: 0 15px 0 0;
    grid-gap: 8px;
  }

  .email-support-header-mobile img {
    vertical-align: middle;
  }
`;

const CustomerContainer = styled.div<CommonStyledComponentProps>`
    .customer-flex{
        display: flex;
        flex-direction: ${(props: any) => props.isMobile ? `row` : `column`};
        margin-left: 8px;
    }
    .myCustIcon{
        justify-content: flex-end;
    }
    .myCustIcon p {
        font-size: ${(props: any) => props.isMobile ? `14px` : `12px`};	
    }
`

export const BackToMintproCTA = () => {
    return isProUser() ? (<HeaderBackCTACont onClick={() => {
        Mixpanel.track(getEventName("backToMintpro", "clicked", "header"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
        redirectToMintPro();
    }}><i className="icon-arrow_left"></i>Back to Mintpro</HeaderBackCTACont>) : null;
}
export const BackToHomeCTA = () => {
    return (<HeaderBackCTACont onClick={() => {
        redirectToHome();
    }}><i className="icon-arrow_left"></i>Back to Home</HeaderBackCTACont>);
}

export interface HeaderProps {
    goBackCallback?: Function,
    title?: string,
    headerIconSet?: any
}
export interface IconProps {
    showLogo: boolean,
    showBackButton: boolean,
    showSearch: boolean,
    showCart: boolean,
    showCallExpert: boolean,
    showRedToMintpro: boolean,
    showBackToHome: boolean,
    iconBackToMintProWeb: boolean,
    showCustomerCount: boolean,
    showYourAdvisorSection: boolean,
    showCustomisedHomeHeader: boolean,
    showEmailUs: boolean,
}


const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
    const history = useHistory();
    const location = useLocation();
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const { currentUserDetails, portfolioDetails } = propsToJS(useSelector(LoginSelector));
    const { countTotalAUM, calculatorLeads, isAgentNotAllowed } = propsToJS(useSelector(UserSelector));
    const { riskProfileResult } = propsToJS(useSelector(RiskProfileViewSelector));
    const { nameInHeader } = propsToJS(useSelector(ProfileViewSelector));
    const [showSearchButton, setShowSearchButton] = useState<boolean>(false);
    const [cartData, setCartData] = useState<any>(cartDetails?.noOfItems);
    const [headerIconsSetFromRoute, setHeaderIconsSetFromRoute] = useState<Partial<IconProps>>();
    const isMobile = useMediaQuery({ maxWidth: 767 });

    useEffect(() => {
        cartDetails && setCartData(cartDetails?.noOfItems);
    }, [useDeepCompare(cartDetails)])    
    

    useEffect(() => {
        setHeaderIconsSetFromRoute(getheaderIconSetForRoute(location.pathname) ? getheaderIconSetForRoute(location.pathname) : props?.headerIconSet);
    }, [location.pathname, props])

    const onGoBackClick = () => {
        if (props.goBackCallback) props.goBackCallback();
        else window.history.go(-1);
    };

    const searchFundsClick = (searchParams: any) => {
        Mixpanel.track(getEventName("search", "clicked", "header"), {
            agentCode: getAgentCode(),
            user: getUserDetails()
        });
        isMobile ? history.push(`search-panel`) : history.push(`search?keywords=${searchParams}`);
    }

    const suggestFunds = (params: any) => {
        Mixpanel.track(getEventName("searchSuggestions", "clicked", "header"), {
            agentCode: getAgentCode(),
            user: getUserDetails()
        });
        if (params?.length > 3) {
            get(`${ENDPOINTS.SUGGEST_MUTUAL_FUNDS}?text=${params}`, getDefaultHeaders(), false)
                .subscribe((response: AjaxResponse | AjaxError) => {
                }, (error: AjaxError) => {
                    console.log(error);
                });
        }
    }
    const showCustomerNAum = () => {
        return ( !isAgentEuin() ? <CustomerContainer isMobile={isMobile}>
            <div className='posR'>
                <div>
                    {!countTotalAUM && <>
                        {
                            isMobile ? <div className="greyTxt aumLoaderMobile">
                                <img src={CustomerLoader} alt="landing-page-loader" />
                                <span>Fetching Customers & AUM</span>
                            </div> :
                                <div className="greyTxt aumLoader">
                                    <img src={CustomerLoader} alt="landing-page-loader" />
                                </div>
                        }
                    </>}

                    {(!isMobile || (isMobile && countTotalAUM )) && <div onClick={() => redirectToCustomerListing()} className="myCustIcon">
                        {!isMobile && <div className='posR'>
                            {calculatorLeads > 0 && <HeaderNoOfItemsContainer style={{ left: '10px' }}>{calculatorLeads}</HeaderNoOfItemsContainer>}
                            <img src={myCustomerSvg} alt="customers AUM icon" />
                        </div>}
                        <p className="grey ml8 customer-flex">
                            <b className="greenTxt">{countTotalAUM?.customerCount} Customers   {isMobile ? '\u00A0' :'' }</b> 
                            AUM: &#x20B9; {(countTotalAUM?.totalAUM)?.toLocaleString('en-IN')}
                        </p>
                    </div>}
                </div>
            </div>
        </CustomerContainer> : null )
    }


    const cartReviewClick = () => {
        Mixpanel.track(getEventName("viewCart", "clicked", "header"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
        redirectToOld(addAgentCode('cart-review'));
    }

    //redirect to customer-listing page when header AUM clicked
    const redirectToCustomerListing = (isEuin?: boolean) => {
        Mixpanel.track(getEventName("myCustomers", "clicked", "header"));
        redirectToOld(isEuin ? addAgentCode('my-customers?isEuin=true') : addAgentCode('my-customers'));
    }
    return (
        <HeaderContainer isMobile={isMobile} className={headerIconsSetFromRoute?.showCustomisedHomeHeader ? '' : 'stickyHeader'}>
            {headerIconsSetFromRoute?.showRedToMintpro && isMobile ? <BackToMintproCTA /> : null}
            {headerIconsSetFromRoute?.showBackToHome && isMobile ? <BackToHomeCTA /> : null}

            <HeaderInnerContainer isMobile={isMobile}>
                <div className={isMobile ? '' : 'upperNav'}>
                    <div className={isMobile ? '' : 'mint-flex mt0'}>
                        <HeaderLeft>
                            {headerIconsSetFromRoute?.showLogo || !isMobile ? <span className={`newLogo ${isMobile ? '' : 'newLogoPadding'}`} style={{ cursor: "pointer" }}
                                onClick={() => redirectToHome('header')}
                                title="Turtlemint Money - Invest in best performing funds by consulting experts for free">
                                <Logo style={{ cursor: "pointer" }} isMobile={isMobile} alt="Turtlemint Money - Invest in best performing funds by consulting experts for free" src={logo1} />
                            </span> : null}
                            {headerIconsSetFromRoute?.showBackButton && isMobile ? <i className="icon-Back headerIconSet" onClick={onGoBackClick}></i> : null}
                            {props.title && isMobile ? <HeaderTitle>{props.title}</HeaderTitle> : null}
                        </HeaderLeft>
                        <HeaderCenter isMobile={isMobile}>
                            {!isMobile ? <HeaderSearch isMobile={isMobile}>
                                <img src={search} alt="Search" />
                                <input
                                    placeholder="Search for anything related to mutual funds."
                                    type="text"
                                    onKeyUp={(e: any) => e.keyCode === 13 ? searchFundsClick(e.target.value) : suggestFunds(e.target.value)}
                                    onChange={(e) => (e.target as HTMLInputElement).value ? setShowSearchButton(true) : setShowSearchButton(false)} />
                                {showSearchButton && <input value="Search" className="srch-btn" type="button" onClick={(e: any) => searchFundsClick(e.target.previousSibling?.value)} style={{ cursor: "pointer", height: '100%' }} />}
                            </HeaderSearch> : null}
                        </HeaderCenter>
                    </div>
                    <ul className={isMobile ? '' : 'upper-ul'}>
                        <HeaderRight isMobile={isMobile}>
                            <div className={`upper-ul-flex ${isMobile ? 'mr-15' : ''}`}>
                                {(headerIconsSetFromRoute?.showSearch && isMobile) && <a href="/v1/search-panel" style={{ margin: "0px 0 0 16px" }}><img src={search} alt="Search" /></a>}
                                {(headerIconsSetFromRoute?.showYourAdvisorSection && isMobile) && <CalculatorAdvisor />}
                                {(headerIconsSetFromRoute?.showCart || !isMobile) ?
                                    <div className="anchorBlack" style={{ cursor: "pointer" }} onClick={cartReviewClick}>
                                        <img src={investmentCart} alt="Investment cart" className="ml15 cartHeader" style={{ marginRight: "20px" }} />
                                        {cartDetails && cartDetails?.noOfItems ? <HeaderNoOfItemsContainer>{cartData}</HeaderNoOfItemsContainer> : null}
                                        {(!isMobile && cartDetails) &&
                                            <div className="cartPreviewBox">
                                                <div className="cartTopArrow"></div>
                                                {cartDetails?.noOfItems === 0 && <h3>Your cart is empty.</h3>}
                                                {cartDetails?.noOfItems === 1 && <h3>{cartDetails?.noOfItems} Product in your Cart.</h3>}
                                                {cartDetails?.noOfItems > 1 && <h3>{cartDetails?.noOfItems} Products in your Cart.</h3>}
                                                {(cartDetails && cartDetails?.activeMintPackInvestmentDetailList) && <h3><em>Mutual Funds</em></h3>}
                                                <article style={{ borderBottom: "none", padding: "0px" }}>
                                                    {(cartDetails && cartDetails?.noOfItems > 0 && cartDetails?.activeMintPackInvestmentDetailList && cartDetails.activeMintPackInvestmentDetailList?.length > 0) && cartDetails.activeMintPackInvestmentDetailList.map((element: any, index: any) => (
                                                        index < 3 && <div key={index} style={{ borderBottom: "solid 1px #dfeef5", padding: "9px 15px" }}>
                                                            <strong><span>{element.packName}</span></strong><br />
                                                            <span>{element.investmentDetail[0].investmentType} , </span>
                                                            {element.investmentDetail[0].investmentFrequency && <span>{investmentFrequencyFilter(element.investmentDetail[0].investmentFrequency)} , </span>}
                                                            <span> &#8377;  {cartDetails?.activeMintPackInvestmentDetailList?.length > 0 && element?.totalAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })} </span>
                                                        </div>
                                                    ))
                                                    }
                                                </article>
                                                {(cartDetails && cartDetails.activeCustomizedInvestmentDetailList) &&
                                                    <div>
                                                        <h3><em>Individual Funds</em></h3>
                                                        <article style={{ borderBottom: "none", padding: "0px" }}>
                                                            {(cartDetails && cartDetails?.noOfItems > 0 && cartDetails.activeCustomizedInvestmentDetailList?.length > 0) && cartDetails.activeCustomizedInvestmentDetailList.map((element: any, index: any) => (
                                                                index < 3 && <div key={index} style={{ borderBottom: "solid 1px #dfeef5", padding: "9px 15px" }}>
                                                                    <strong><span>{element.investmentDetail[0].mutualFund.fundName}</span></strong><br />
                                                                    <span>{element.investmentDetail[0].investmentType} , </span>
                                                                    {element.investmentDetail[0].investmentFrequency && <span>{investmentFrequencyFilter(element.investmentDetail[0].investmentFrequency)} , </span>}
                                                                    <span> ,&#8377;  {cartDetails.activeCustomizedInvestmentDetailList?.length > 0 && element?.totalAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })} </span>

                                                                </div>
                                                            ))
                                                            }
                                                        </article>
                                                    </div>
                                                }
                                                {(cartDetails && cartDetails?.noOfItems > 0) &&
                                                    <ViewCartButton onClick={() => redirectToOld(addAgentCode('cart-review'))}>View Cart </ViewCartButton>}
                                            </div>
                                        }
                                    </div> : null}

                                {((isProUser() && !isAgentEuin()) && (!isMobile && headerIconsSetFromRoute?.showCustomerCount)) && showCustomerNAum()}

                                {(headerIconsSetFromRoute?.showEmailUs || !isMobile) && <div className={isMobile ? "email-support-header-mobile" : "email-support-header"}>
                                    <a href="mailto:help@turtlemintmoney.com"><img src={emailBtn} alt="Email Us" /></a>
                                    {!isMobile &&
                                        <p className="green"><a href="mailto:help@turtlemintmoney.com" style={{ color: "#00A465", fontWeight: "bold" }}>help@turtlemintmoney.com</a><br></br>
                                            <span className='headerText'>Email Support</span>
                                        </p>}
                                </div>}

                                {(headerIconsSetFromRoute?.showCallExpert || !isMobile) && <div className={isMobile ? "expert-call-header-mobile" : "expert-call-header"} >
                                    <a href="tel:18002666468"><img src={callBtn} alt="call expert" /></a>
                                    {!isMobile &&
                                        <p className="green"><a href="tel:18002666468" style={{ color: "#00A465", fontWeight: "bold" }}>18002666468</a><br />
                                            <span className='headerText'>Helpline</span>
                                        </p>}
                                </div>}

                                {(isProUser() && !isAgentEuin() && (isMobile && headerIconsSetFromRoute?.showCustomerCount)) && <div className='posR'>
                                    {calculatorLeads > 0 && <HeaderNoOfItemsContainer style={{ left: '10px' }}>{calculatorLeads}</HeaderNoOfItemsContainer>}
                                    <img src={myCustomerSvg} alt="customers AUM icon" onClick={() => redirectToCustomerListing(isAgentEuin() ? true : false)} />
                                </div>}

                                {!isMobile && <div>
                                    {isProUser() ? <div>
                                        {

                                            headerIconsSetFromRoute?.iconBackToMintProWeb ? <div>
                                                <a onClick={() => redirectToMintPro()}>
                                                    <img src={backToMintPro} className="back-mintpro" />
                                                    <span className='headerText'>Back to Mintpro</span>
                                                </a>
                                            </div> :
                                                <div style={{ marginRight: "-120px" }}></div>
                                        }
                                    </div> : <div>
                                        {(!getUserDetails()) ? <div > <LoginSignUpButton onClick={() => elementVisibilty.show('loginDiv')}>Login / Sign Up</LoginSignUpButton></div> :
                                            <div className="NewloginBtn">
                                                <a style={{ display: "flex" }} className="headLogIn">
                                                    <img src={profile}></img>&nbsp;
                                                    <span className="profile-header">
                                                        <span className="name-ellipsis">{nameInHeader?.toLowerCase()}</span>
                                                        {(portfolioDetails && portfolioDetails.netAmountInvested > 0) &&
                                                            <p className={portfolioDetails.netCurrentValue > portfolioDetails.netAmountInvested ? 'changesUp' : 'changesDown'}>
                                                                ₹{portfolioDetails?.netCurrentValue?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}
                                                                ({portfolioDetails.netReturnPercentage.toFixed(2)}%)
                                                            </p>
                                                        }
                                                    </span>
                                                </a>
                                                <div className="profileDropBox text-center">
                                                    <div className="cartTopArrow"></div>
                                                    <ul>
                                                        <li><a onClick={() =>{
                                                            Mixpanel.track(getEventName("viewProfile", "clicked", "header"), {
                                                                agentCode: getAgentCode(),
                                                                user: getUserDetails(),
                                                                isBtoCFlow: isBtoCFlow(),
                                                            });
                                                            history.push('/profile');
                                                        }}>Profile</a></li>
                                                        <li><a onClick={() =>
                                                            riskProfileResult ? history.push('/profile/risk-profile-result?flowType=profile') :
                                                                history.push('/profile/risk-profile?flowType=profile')}>Risk Profile</a></li>
                                                        <li><a
                                                            onClick={() => {
                                                                Mixpanel.track(getEventName("viewPortfolio", "clicked", "header"), {
                                                                    agentCode: getAgentCode(),
                                                                    user: getUserDetails(),
                                                                    isBtoCFlow: isBtoCFlow(),
                                                                });
                                                                history.push('/profile/portfolio')
                                                            }}
                                                        >Portfolio</a></li>
                                                        <li><a href={addAgentCode('/running-sips')}
                                                            onClick={() =>
                                                                Mixpanel.track(getEventName("viewRunningSIPs", "clicked", "header"), {
                                                                    agentCode: getAgentCode(),
                                                                    user: getUserDetails(),
                                                                    isBtoCFlow: isBtoCFlow(),
                                                                })}
                                                        >My SIPs</a></li>
                                                        <li><a href={addAgentCode('/transaction')}
                                                            onClick={() =>
                                                                Mixpanel.track(getEventName("viewTransactions", "clicked", "header"), {
                                                                    agentCode: getAgentCode(),
                                                                    user: getUserDetails(),
                                                                    isBtoCFlow: isBtoCFlow(),
                                                                })}
                                                        >Transactions</a></li>
                                                        <li><a
                                                            onClick={() => {
                                                                Mixpanel.track(getEventName("mandates", "clicked", "header"), {
                                                                    agentCode: getAgentCode(),
                                                                    user: getUserDetails(),
                                                                    isBtoCFlow: isBtoCFlow(),
                                                                });
                                                                history.push('/profile/mandates')
                                                            }}
                                                        >Mandate</a></li>
                                                        <li><a onClick={() => {
                                                            history.push("/profile/stps");
                                                            Mixpanel.track(getEventName("viewMyStps", "clicked", "header"))
                                                        }}>My STPs</a></li>
                                                        <li><a onClick={logOutUser} id="lgtt_loginBtn">Logout</a></li>
                                                    </ul>
                                                </div>
                                            </div>}
                                    </div>}
                                </div>
                                }

                            </div>
                        </HeaderRight>
                    </ul>
                </div>
                <div style={{ clear: 'both' }}></div>
                {isMobile && headerIconsSetFromRoute?.showCustomisedHomeHeader ?
                    <>
                        {isProUser() && (currentUserDetails ? <p className="exitFont">
                            You are logged into {getName()}'s account. <span className="greenTxt boldText cursorP" onClick={logOutUser}>Exit Account </span>
                        </p> : showCustomerNAum()
                        )}
                        <div className='mt8'>
                            <HeaderSearch isMobile={isMobile}>
                                <img src={search} alt="Search" />
                                <input
                                    placeholder="search 3000+ mutual funds"
                                    type="text"
                                    onClick={() => history.push('/search-panel')}
                                />
                            </HeaderSearch>
                        </div>
                        <BrowseFunds />
                    </>
                    : null}
            </HeaderInnerContainer>
        </HeaderContainer >
    )
};

export default Header;
